import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_vendor_list = createAsyncThunk("vendor", async (data) => {
  const body = new FormData();
  body.append("userid", 1);
  body.append("ingress", 1);
  body.append("page", data.page);
  body.append("limit", data.rows);
  const response = await fetch(baseUrl + "vendorlist.php", {
    method: "POST",
    body: body, 
  });
  const res = await response.json();
  return res;
});

export const get_all_vendor_list = createAsyncThunk(
  "all_vendor",
  async (data) => {
    const body = new FormData();
    body.append("userid", 1);
    body.append("ingress", 1);
    body.append("page", 1);
    body.append("limit", 1000);
    const response = await fetch(baseUrl + "vendorlist.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    return res;
  }
);

const initialState = {
  vendor_list: [],
  loading: false,
  all_vendor_list: [],
  all_loading: false,
  total_vendor_count: 0,
};
const vendorSlice = createSlice({
  name: "vendor",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(get_vendor_list.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(get_vendor_list.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(get_vendor_list.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      state.loading = false;
      if (data.success) {
        state.total_vendor_count = data.totalcount;
        state.vendor_list = data.reponselist;
      } else {
        state.vendor_list = [];
      }
    });

    builder.addCase(get_all_vendor_list.pending, (state, action) => {
      state.all_loading = true;
    });
    builder.addCase(get_all_vendor_list.rejected, (state, action) => {
      state.all_loading = false;
    });
    builder.addCase(get_all_vendor_list.fulfilled, (state, action) => {
      state.all_loading = false;
      const data = action.payload;
      if (data.success) {
        state.all_vendor_list = data.reponselist;
      } else {
        state.all_vendor_list = [];
      }
    });
  },
});
export default vendorSlice.reducer;
